module.exports = require("./fr-GF");